const Roles = ['superAdmin', 'admin', 'user'];

export default Roles;
